import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { whyChooseUs } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const WhyChooseUsItem = ({ item, index }) => {
  const [itemRef, itemVisible] = useScrollAnimation(0.2);

  return (
    <div
      ref={itemRef}
      className={`scroll-fade-in ${itemVisible ? 'visible' : ''} stagger-${index + 1}`}
    >
      <div className="flex items-start gap-4 p-6 bg-gradient-to-r from-blue-500/10 to-transparent border border-blue-500/20 rounded-xl hover:border-blue-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/10 group">
        <div className="flex-shrink-0 w-12 h-12 bg-blue-600/10 border border-blue-500/30 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <CheckCircle2 className="w-6 h-6 text-blue-400" />
        </div>
        <div>
          <h3 className="text-xl font-bold mb-2 text-white group-hover:text-blue-400 transition-colors">
            {item.title}
          </h3>
          <p className="text-gray-400">
            {item.description}
          </p>
        </div>
      </div>
    </div>
  );
};

const WhyChooseUs = () => {
  const [headerRef, headerVisible] = useScrollAnimation(0.2);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div 
          ref={headerRef}
          className={`text-center mb-16 scroll-fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-white to-blue-400 bg-clip-text text-transparent">
            Why Choose Us
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Industry-leading expertise and commitment to excellence
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {whyChooseUs.map((item, index) => (
            <WhyChooseUsItem key={index} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
